<div class="chat-container">
    <!-- ── Sidebar ── -->
    <div class="chat-sidebar" [class.hidden-mobile]="chat_uuid">
        <div class="sidebar-header">
            <div class="header-top">
                <h2>Live Chat</h2>
                <div class="volume-control">
                    <svg class="volume-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        fill="currentColor" viewBox="0 0 16 16">
                        <path *ngIf="volume > 0"
                            d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12zM6.312 6.39 8 5.04v5.92L6.312 9.61A.5.5 0 0 0 6 9.5H4v-3h2a.5.5 0 0 0 .312-.11" />
                        <path *ngIf="volume > 0.5"
                            d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z" />
                        <path *ngIf="volume == 0"
                            d="M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06M10 5.04 8.312 6.39A.5.5 0 0 1 8 6.5H6v3h2a.5.5 0 0 1 .312.11L10 10.96z" />
                    </svg>
                    <input type="range" min="0" max="1" step="0.1" [value]="volume"
                        (change)="changeVolume($event)" />
                    <span class="volume-label">{{volume * 100}}%</span>
                </div>
            </div>

            <!-- Player code search -->
            <div class="chat-search">
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                    fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
                <input type="text" class="search-input" [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchInput()" (keydown.enter)="onSearchInput()"
                    placeholder="Search player code / name..." />
                <button class="search-clear" *ngIf="searchTerm" (click)="clearSearch()" title="Clear">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </div>

            <!-- Status Filter -->
            <div class="filter-tabs">
                <button class="filter-tab" [class.active]="filter == 'unread'"
                    (click)="filterChat('unread')">Unread</button>
                <button class="filter-tab" [class.active]="filter == 'read'"
                    (click)="filterChat('read')">Read</button>
                <button class="filter-tab" [class.active]="filter == 'all'"
                    (click)="filterChat('all')">All</button>
            </div>

            <!-- Channel Filter (dynamic from channel list) -->
            <div class="channel-tabs">
                <button class="channel-tab" [class.active]="channelFilter == 'all' && !channelIdFilter"
                    (click)="filterChannel('all')">All</button>

                <!-- Always show internal/web channel -->
                <button class="channel-tab" [class.active]="channelFilter == 'internal' && !channelIdFilter"
                    (click)="filterChannel('internal')">
                    <svg class="channel-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                        <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125" />
                    </svg>
                    Web
                </button>

                <!-- Dynamic channels from DB -->
                <ng-container *ngFor="let ch of channels">
                    <div class="channel-tab-wrapper" *ngIf="ch.status === 1">
                        <!-- Normal display -->
                        <button class="channel-tab"
                            *ngIf="editingChannelId !== ch.id"
                            [class.active]="channelIdFilter == ch.id"
                            [class.active-whatsapp]="channelIdFilter == ch.id && ch.channel == 'whatsapp'"
                            (click)="filterByChannelId(ch)">
                            <!-- Channel icons -->
                            <svg *ngIf="ch.channel === 'whatsapp'" class="channel-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326z" />
                            </svg>
                            <svg *ngIf="ch.channel === 'telegram'" class="channel-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
                            </svg>
                            <svg *ngIf="ch.channel !== 'whatsapp' && ch.channel !== 'telegram'" class="channel-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                            </svg>
                            {{ch.name}}
                            <!-- Edit button -->
                            <span class="channel-action-btn" (click)="startEditChannel(ch, $event)" title="Edit name">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                </svg>
                            </span>
                            <!-- Delete button -->
                            <span class="channel-action-btn channel-delete-btn" (click)="deleteChannel(ch, $event)" title="Delete channel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </span>
                        </button>

                        <!-- Inline edit mode -->
                        <div class="channel-edit-inline" *ngIf="editingChannelId === ch.id">
                            <input type="text" [(ngModel)]="editingChannelName"
                                (keydown.enter)="saveChannelName(ch, $event)"
                                (keydown.escape)="cancelEditChannel($event)"
                                class="channel-edit-input"
                                autofocus />
                            <button class="channel-edit-save" (click)="saveChannelName(ch, $event)" title="Save">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                                </svg>
                            </button>
                            <button class="channel-edit-cancel" (click)="cancelEditChannel($event)" title="Cancel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Chat List -->
        <div class="chat-list">
            <!-- Empty State -->
            <div class="empty-list" *ngIf="chats.length === 0 && !loading_more_chats && !chatLoadFailed">
                <div class="empty-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#94a3b8"
                        viewBox="0 0 16 16">
                        <path
                            d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    </svg>
                </div>
                <p>No conversations yet</p>
            </div>

            <!-- Chat Items -->
            <button *ngFor="let chat of chats" class="chat-item"
                [class.active]="chat.room_id == chat_uuid"
                [class.pinned]="chat.pinned && chat.room_id != chat_uuid"
                (click)="loadChat(chat)">

                <!-- Avatar -->
                <div class="chat-avatar"
                    [class.whatsapp]="chat.channel === 'whatsapp'"
                    [class.internal]="!chat.channel || chat.channel === 'internal'">
                    {{(chat.display_name || chat.contact_name || chat.user || 'A').charAt(0).toUpperCase()}}
                    <div class="channel-badge"
                        [class.badge-whatsapp]="chat.channel === 'whatsapp'"
                        [class.badge-internal]="!chat.channel || chat.channel !== 'whatsapp'">
                        <!-- WhatsApp icon -->
                        <svg *ngIf="chat.channel === 'whatsapp'" xmlns="http://www.w3.org/2000/svg" width="10"
                            height="10" fill="#fff" viewBox="0 0 16 16">
                            <path
                                d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326z" />
                        </svg>
                        <!-- Web icon -->
                        <svg *ngIf="!chat.channel || chat.channel !== 'whatsapp'"
                            xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="#fff"
                            viewBox="0 0 16 16">
                            <path
                                d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                        </svg>
                    </div>
                </div>

                <!-- Chat Info -->
                <div class="chat-info">
                    <div class="chat-top-row">
                        <span class="chat-name">{{chat.display_name || chat.contact_name || chat.user ||
                            "Anonymous"}}</span>
                        <span class="chat-time">{{chat.last_message | date:'dd MMM, HH:mm'}}</span>
                    </div>
                    <div class="chat-bottom-row">
                        <span class="chat-preview">{{chat.last_text || (chat.last_message | date:'dd MMM yyyy, HH:mm')}}</span>
                        <span class="unread-badge" *ngIf="chat.unread > 0">{{chat.unread}}</span>
                    </div>
                </div>

                <!-- Pin indicator -->
                <div class="pin-indicator" *ngIf="chat.pinned">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5a.5.5 0 0 1-1 0V10h-4A.5.5 0 0 1 3 9.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                    </svg>
                </div>
            </button>

            <!-- Load More -->
            <p class="text-center px-3" role="alert" *ngIf="chatLoadFailed">Unable to load conversations. Please try again.</p>
            <button class="load-more-btn" *ngIf="hasMoreChats || chatLoadFailed || loading_more_chats" [disabled]="loading_more_chats"
                (click)="getChats()">
                <span *ngIf="!loading_more_chats">{{chatLoadFailed ? 'Retry' : 'Load more conversations'}}</span>
                <span *ngIf="loading_more_chats">
                    Loading
                    <span class="loading-indicator">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </span>
                </span>
            </button>
        </div>
    </div>

    <!-- ── Main Chat Area ── -->
    <!-- Empty State (no chat selected) -->
    <div class="empty-chat-state" *ngIf="!chat_uuid">
        <div class="empty-illustration">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6366f1" viewBox="0 0 16 16">
                <path
                    d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                <path
                    d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
        </div>
        <h3>Select a conversation</h3>
        <p>Choose a chat from the sidebar to start messaging</p>
    </div>

    <!-- Active Chat -->
    <div class="chat-main" *ngIf="chat_uuid" [class.hidden-mobile]="!chat_uuid">

        <!-- Chat Header -->
        <div class="chat-header">
            <div class="header-left">
                <button class="back-btn" (click)="backToList()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                    </svg>
                </button>
                <div class="header-avatar"
                    [class.whatsapp]="chat.channel === 'whatsapp'"
                    [class.internal]="!chat.channel || chat.channel !== 'whatsapp'">
                    {{(chat.display_name || chat.contact_name || chat.user || 'A').charAt(0).toUpperCase()}}
                </div>
                <div class="header-info">
                    <div class="header-name">
                        {{chat.display_name || chat.contact_name || chat.user || "Anonymous"}}
                        <span *ngIf="isLoading" class="loading-indicator">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </span>
                    </div>
                    <span class="header-channel"
                        [class.channel-whatsapp]="chat.channel === 'whatsapp'"
                        [class.channel-internal]="!chat.channel || chat.channel !== 'whatsapp'">
                        <svg *ngIf="chat.channel === 'whatsapp'" xmlns="http://www.w3.org/2000/svg" width="10"
                            height="10" fill="currentColor" viewBox="0 0 16 16">
                            <path
                                d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326z" />
                        </svg>
                        {{chat.channel === 'whatsapp' ? 'WhatsApp' : 'Web Chat'}}
                    </span>
                </div>
            </div>

            <div class="header-actions">
                <!-- End Chat -->
                <button class="action-btn end-chat-btn" *ngIf="show_end_chat" (click)="endChat()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                    </svg>
                    End Chat
                </button>

                <!-- Pin Chat -->
                <button class="action-btn" (click)="pinnChat(chat_uuid!)" title="Pin conversation">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5a.5.5 0 0 1-1 0V10h-4A.5.5 0 0 1 3 9.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                    </svg>
                </button>

                <!-- View Player -->
                <a *ngIf="chat.user_id" class="action-btn"
                    [routerLink]="['/lo', company_uuid, 'wallet-topup-withdraw']"
                    [queryParams]="{player: chat.player_uuid}" title="View player">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                </a>
            </div>
        </div>

        <!-- Message Area -->
        <div class="message-area" #messageContainer>
            <!-- Load older messages -->
            <button class="load-older-btn" *ngIf="hasMoreMessages" (click)="loadOldMessages()">
                Load older messages
            </button>
            <div class="no-more-messages" *ngIf="!hasMoreMessages">
                Beginning of conversation
            </div>

            <!-- Messages -->
            <ng-container *ngFor="let message of messages">
                <!-- System message -->
                <div class="message-row system-row" *ngIf="message.type === 'system'">
                    <div class="system-bubble" [innerHTML]="html(message.message)"></div>
                </div>

                <!-- Chat message -->
                <div class="message-row" *ngIf="message.type === 'chat' || message.type !== 'system'"
                    [class.from-admin]="message.admin_id || message.user_type === 'admin'"
                    [class.from-user]="!message.admin_id && message.user_type !== 'admin'">

                    <div class="bubble" [class.deleted]="message.status == 99">
                        <div class="msg-sender">
                            {{ message.user != "null" ? message.user : 'Anonymous' }}
                        </div>
                        <div class="msg-text" [innerHTML]="html(message.message)"></div>
                        <div class="msg-time">
                            {{ message.timestamp | date:'HH:mm' }}
                            <span *ngIf="message.status == 99" class="deleted-label">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                                    viewBox="0 0 16 16">
                                    <path
                                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                                </svg>
                                Deleted
                            </span>
                        </div>
                    </div>

                    <!-- Delete button (only for admin messages, not deleted) -->
                    <button class="delete-btn"
                        *ngIf="message.status != 99 && (message.user_type == 'admin' || message.admin_id)"
                        (click)="deleteMessage(message.id)" title="Delete message">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                            viewBox="0 0 16 16">
                            <path
                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path fill-rule="evenodd"
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3V2h11v1z" />
                        </svg>
                    </button>
                </div>
            </ng-container>
        </div>

        <!-- Input Area -->
        <div class="alert alert-info m-3" *ngIf="(!chat.channel || chat.channel === 'internal') && !chat.account_player_id">
            Archived conversation: historical customer identity is unverified. New replies must use the account chat opened after the player signs in.
        </div>
        <div class="chat-input-area" *ngIf="(chat.channel && chat.channel !== 'internal') || chat.account_player_id">
            <div class="input-wrapper">
                <textarea [(ngModel)]="message" placeholder="Type a message..."
                    (keydown.enter)="onEnterKey($event)"
                    rows="1"></textarea>
                <div class="input-actions">
                    <!-- Image upload -->
                    <input type="file" class="d-none" (change)="sendImage($event)" id="image" accept="image/*" />
                    <label for="image" class="input-icon-btn" style="cursor:pointer; margin:0;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                            viewBox="0 0 16 16">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            <path
                                d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                        </svg>
                    </label>
                    <!-- Template -->
                    <button class="input-icon-btn" (click)="sendTemplate()" [disabled]="is_sending"
                        title="Send template">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                            viewBox="0 0 16 16">
                            <path
                                d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
                            <path
                                d="M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                        </svg>
                    </button>
                    <!-- Send -->
                    <button class="send-btn" (click)="sendMessage()" [disabled]="is_sending || !message?.trim()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                            viewBox="0 0 16 16">
                            <path
                                d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
